import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { HttpService } from '../../base/http.service';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    private httpService: HttpService,
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute
  ) {
    this.createFormGroup();
  }
  @Input() class: string = '';

  public formGroup: FormGroup;
  public isHumberger = false;
  public isPanel = false;
  public account: any = { type: '' };
  public languageOption = ['English', 'Japanese'];
  public arrayPath: string[] = [];

  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4]?.match(/jp/)) {
      this.formGroup.controls.language.setValue('Japanese');
    } else {
      this.formGroup.controls.language.setValue('English');
    }
  }

  public createFormGroup() {
    this.formGroup = this.builder.group({
      language: new FormControl('Japanese', []),
    });
  }

  public onHumberger(): any {
    this.isHumberger = !this.isHumberger;

    if (!this.isHumberger) {
      let body: any = document.getElementsByTagName('body');
      body.item(0).removeChild(body.item(0).firstChild);
      let ele: any = body.item(0);
      ele.setAttribute('style', 'overflow: auto;');
    } else {
      const body: any = document.getElementsByTagName('body');
      const ele: any = body.item(0);
      ele.setAttribute('style', 'overflow: hidden;');

      const newEle = document.createElement('div');
      newEle.setAttribute(
        'style',
        'height: 100vh;width: 100vh;background:rgba(226, 226, 226,0.5);z-index: 2;position: absolute;transition: all 0.5s;left: 0;'
      );
      ele.prepend(newEle);
    }
  }

  public onMenuScroll(menuClass: string): any {
    this.isHumberger = !this.isHumberger;

    const body: any = document.getElementsByTagName('body');
    body.item(0).removeChild(body.item(0).firstChild);
    const ele: any = body.item(0);
    ele.setAttribute('style', 'overflow: auto;');

    const element = document.getElementById(menuClass);
    const rect = element.getBoundingClientRect();
    const elemtop = rect.top + window.pageYOffset;
    scroll(elemtop - 100, elemtop - 100);
  }

  public onLogout() {
    this.httpService.post('local/logout', {}).subscribe(
      (value) => this.router.navigate(['/'], {}),
      (error) => console.log(error),
      () => console.log('onCompleted')
    );
  }

  public changeLanguage() {
    this.isHumberger = false;

    let body: any = document.getElementsByTagName('body');
    body.item(0).removeChild(body.item(0).firstChild);
    let ele: any = body.item(0);
    ele.setAttribute('style', 'overflow: auto;');
    if (this.formGroup.value.language === 'Japanese') {
      this.formGroup.controls.language.setValue('Japanese');
      this.router.navigate(['/' + this.arrayPath[3] + '/jp']);
    } else {
      this.router.navigate([
        '/' + (this.arrayPath[3] === 'jp' ? '' : this.arrayPath[3]),
      ]);
    }
  }

  public getUrl() {
    let language = '';
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4]?.match(/jp/)) {
      language = '/jp';
    } else {
      language = '';
    }
    return language;
  }
}
